import { useSelectedLocation } from "components/DealersAndLocationsDropdown/hooks";
import { useTypedQuery } from "hooks";
import { AppointmentsQueryKeys } from "modules/Appointments/queryKeys";
import { ApiInstance } from "utils/Api";

export const useWoNrQuery = () => {
  const { selectedLocation } = useSelectedLocation();

  const query = useTypedQuery({
    queryKey: AppointmentsQueryKeys.woNumber,
    queryFn: async ({ endpoint, baseUrl }) => (await ApiInstance.post(endpoint, { dealer_location_id: selectedLocation?.id }, baseUrl)).data.wo_nr,
    enabled: false
  });

  return query;
};
